<form class="popupForm" style="min-height: {{minHeight}}px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      {{ (previewMode ? 'view_player' : 'add_new_friend') | GetLabelPipe}}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="state==='default'">
      <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important;min-height: {{(minHeight-50)}}px;">
        <br/>
        <div *ngIf="isError">
          >.< error. <br>{{errMsg}}
        </div>

        <ng-container *ngIf="!this.profile">
          <div>
            {{'enter_phone_number' | GetLabelPipe}}
          </div>
          <mat-form-field appearance="outline" color="accent" style="width: 100%">
  <!--          <mat-label>Phone number</mat-label>-->
  <!--          <span matPrefix>+380 &nbsp;</span>-->
            <input matInput type="text"
                   (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
                   formControlName="phoneInput">
            <button *ngIf="phoneInput.value" matSuffix mat-icon-button aria-label="Clear" (click)="phoneInput.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
               *ngIf="validationResult && !validationResult.isValid && validationResult.message">
            <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message}}</span>
          </div>
          <br/>
        </ng-container>

        <ng-container *ngIf="this.profile && !this.profile.id">
          <div class="field-bigger-info-message" [innerHTML]="'user_not_found_by_phone' | GetLabelPipe: -1:null:[phoneInput.value]">
          </div>
        </ng-container>

        <ng-container *ngIf="!isSearching && !this.profile?.id">
          <mat-accordion multi>
            <mat-expansion-panel [expanded]="this.profile && !this.profile.id">
              <mat-expansion-panel-header>
                <div class="expansion-panel-header">
                  <mat-icon class="expansion-icon">share</mat-icon>
                  <div>
                    {{'manually_share_bot_link_title' | GetLabelPipe}}
                  </div>
                </div>
              </mat-expansion-panel-header>

              <ng-container *ngIf="afterInit">
                <div class="field-bigger-info-message">
                  {{'manually_share_bot_link_message' | GetLabelPipe}}
                </div>
                <div class="copy-wrapper" fxLayout="row">
                  <input type="text" formControlName="shareInput" readonly>
                  <div class="icon-wrapper icon-wrapper-right" (click)="copyLink()">
                    <mat-icon color="accent">content_copy</mat-icon>
                  </div>
                </div>
              </ng-container>
            </mat-expansion-panel>
          </mat-accordion>
          <br/>
        </ng-container>

        <ng-container *ngIf="this.profile?.id">
          <div class="event-view-content event-view-content-first-row" style="justify-content: flex-start;">
            <div class="flex-column-center">
              <div class="event-user-icon event-user-icon-first-row" (click)="showUser(profile)">
                <img src="{{profile.picture_src_preview}}"
                     alt="{{profile.shipping_name}}" title="{{profile.shipping_name}}"
                     style="{{ profile.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
                />
              </div>
              <div class="user-name user-name-as-link">
                {{profile.shipping_name}}
              </div>
            </div>
            <div class="event-description flex-column-center flex-justify-space-around" style="margin-bottom: 30px;"
                 *ngIf="relationParams['message']">
              <div style="font-size: 0.9em;">{{relationParams['message']}}</div>
              <button *ngIf="relationParams['action_type'] && relationParams['action_type']!='remove_from_friends'" [disabled]="isUpdating"
                      mat-raised-button class="cancel widerButton font16" color="accent"
                      style="margin-top: 20px;"
                      (click)="updateRelation(relationParams['action_type'])">
                <mat-icon>{{relationParams['action_icon']}}</mat-icon>
                &nbsp;{{relationParams['actionLabel']}}
              </button>
            </div>
          </div>
        </ng-container>

        <div class="internal-spinner internal-form-spinner" *ngIf="isSearching">
          <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg>
        </div>

      </mat-dialog-content>
      <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
        <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
          {{'close'|GetLabelPipe}}
        </button>
        <button [disabled]="isSearching" type="submit" class="widerButton font16" mat-raised-button
                color="accent"
                *ngIf="!profile"
                (click)="handleSubmit()">
          <mat-icon>search</mat-icon> {{'search'|GetLabelPipe}}
        </button>
        <button [disabled]="isSearching" type="submit" class="widerButton font16" mat-raised-button
                color="accent"
                *ngIf="profile && !previewMode"
                (click)="profile = null">
          <mat-icon>search</mat-icon> {{'new_search'|GetLabelPipe}}
        </button>
      </div>
    </ng-container>
  </div>
</form>
